"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'webhook.eventTypes.conversation_analysis': '对话分析',
    'webhook.eventTypes.avatar_updated': '头像更新',
    'webhook.eventTypes.avatar_deleted': '头像已删除',
    'webhook.eventTypes.avatar_test_complete': '头像测试完成',
    'webhook.eventTypes.knowledge_added': '知识添加',
    'webhook.eventTypes.knowledge_removed': '知识删除',
    'webhook.eventTypes.knowledge_notify': '编辑知识',
};
